'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import BusinessAccuracy from './_components/BusinessAccuracy';
import BusinessBringToWork from './_components/BusinessBringToWork';
import BusinessCards from './_components/BusinessCards';
import BusinessCaseStudy from './_components/BusinessCaseStudy';
import BusinessContactUs from './_components/BusinessContactUs';
import BusinessCustomers from './_components/BusinessCustomers';
import BusinessGallery from './_components/BusinessGallery';
import BusinessHealth from './_components/BusinessHealth';
import BusinessHero from './_components/BusinessHero';
import BusinessHowWeCanHelp from './_components/BusinessHowWeCanHelp';
import BusinessIndustry from './_components/BusinessIndustry';
import BusinessMenu from './_components/BusinessMenu';
import BusinessOfferings from './_components/BusinessOfferings';
import HubspotSelectionModal from './_components/HubspotSelectionModal';
import { HubspotFormsProvider } from './_contexts/HubspotFormsContext';
import {
  businessGradients1,
  businessGradients2,
  businessGradients3,
} from './_data/businessGradients';

const Content = (): JSX.Element => {
  useScrollTracking();

  return (
    <HubspotFormsProvider>
      <RadialGradientBG
        background="sandstone-200"
        gradients={businessGradients1}
      >
        <BusinessHero />
        <BusinessContactUs />
        <BusinessOfferings />
      </RadialGradientBG>
      <RadialGradientBG
        background="sandstone-200"
        gradients={businessGradients2}
      >
        <BusinessBringToWork />
        <BusinessGallery />
        <BusinessHowWeCanHelp />
        <BusinessMenu />
        <BusinessCaseStudy />
      </RadialGradientBG>
      <BusinessAccuracy />
      <RadialGradientBG
        background="sandstone-200"
        gradients={businessGradients3}
      >
        <BusinessIndustry />
        <BusinessCards />
        <BusinessCustomers />
        <BusinessHealth />
      </RadialGradientBG>
      <HubspotSelectionModal />
    </HubspotFormsProvider>
  );
};

export default Content;
